import RoundedImage from './index';
import { RoundedImageSizes } from './RoundedImage';
import UserProfileData from '../../../types/userProfileData';
import { getDefaultUserImageUrl } from '../../../utils/functions';
import { useProfileImageUrl } from '../../../utils/hooks';

interface UserThumbnailProps {
  userProfile: UserProfileData;
  size?: RoundedImageSizes;
  className?: string;
}

/**
 * A specific type of RoundedImage component made for convenience. Takes a user profile and renders the user's image.
 * @param userProfile
 * @param size
 * @param className
 * @constructor
 */
export default function UserRoundedImage({ userProfile, size = 'sm', className = '' }: UserThumbnailProps) {
  const profileImage = useProfileImageUrl(userProfile?.imageStoragePath);
  return (
    <RoundedImage
      className={className}
      size={size}
      src={profileImage ? profileImage : getDefaultUserImageUrl()}
      alt="User uploaded profile"
    />
  );
}
